export default __webpack_public_path__ + "static/media/Program-OT-Bold.32ba14b0.otf";